import React from 'react';
import Navbar from '../layout/Navbar';
import WildernessPsychotherapySection from './WildernessPsychotherapySection';
import ContactSection from '../home/ContactSection';
import Footer from '../layout/Footer';
import GlobalStyles from '../layout/GlobalStyles';

const WildernessPsychotherapyPage = () => {
  return (
    <>
      <GlobalStyles />
      <Navbar />
      <WildernessPsychotherapySection />
      <ContactSection />
      <Footer />
    </>
  );
};

export default WildernessPsychotherapyPage;